<template>
  <div class="p-5">
    <h3 class="m-0">ChallengePage</h3>
    <router-link to='/challenge/1/dashboard'>dashboard</router-link> |
    <router-link to='/challenge/1/discussion-faq'>discussion-faq</router-link> |
    <router-link to='/challenge/1/cohort'>cohort</router-link> |
    <router-link to='/challenge/1/success-stories'>success-stories</router-link> |
    <router-link to='/challenge/1/sessions'>sessions</router-link> |
    <el-card>
      <router-view></router-view>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "ChallengePage",
  data: () => ({
  }),
  computed: {
  },
  methods: {
  },
  components: {
  }
};
</script>

<style>
</style>
